import React from 'react';
import Message from './Message';
import '../styles/ToastStack.css';

function ToastStack({ items = [], className = '' }) {
  const normalizedItems = items.filter((item) => item && item.text);
  if (normalizedItems.length === 0) return null;

  const rootClassName = ['toast-stack', className].filter(Boolean).join(' ');

  return (
    <div className={rootClassName} aria-live="polite" aria-atomic="true">
      {normalizedItems.map((item, index) => (
        <div
          key={item.id || `${item.type || 'info'}-${item.text}-${index}`}
          className="toast-stack__item"
        >
          <Message text={item.text} type={item.type} mode="toast" />
        </div>
      ))}
    </div>
  );
}

export default ToastStack;
